<div class="flex-direction-column justify-between card-fila cursor-pointer" (click)="selecionarCard()"
     (keydown.enter)="selecionarCard()" tabindex="0" role="button">
  <div class="width-100 flex justify-between">
    <div class="flex gap-5">
      <div class="flex align-start">
        <div [matTooltip]="toolTipFotoContato(fila)">
          <img width="40px" height="40px" [src]="verificarFotoContato(fila)" [alt]="fila?.nomeContato ?? ''"/>
        </div>
      </div>
      <div class="flex-direction-column gap-5">
        <span class="font-10 weight-600">{{ fila?.nomeContato ?? '--' }}</span>
        <span class="font-10 weight-400">{{ fila?.numeroContato | celularMask }}</span>
        <span class="font-10 weight-400">Data Entrada: {{ fila?.dataEntradaSessao | date: 'dd/MM/yyyy' }}</span>
      </div>
    </div>
    <div class="flex-direction-column gap-5">
      <div>
        <app-progress-bar-data
          height="16px" width="100%"
          [data]="fila?.dataFormatadaFinalizar!"
          [tempoFinalizar]="fila?.tempoFinalizarSessao!"
          [verificaFinalizada]="true"
         >
        </app-progress-bar-data>
      </div>
      <div>
        <span class="font-10 weight-400">T. Sessão: {{ converterParaHoraMinuto(fila?.tempoTotalSessao!) }}</span>
      </div>
      <div>
        <span class="font-10 weight-400">T. Espera: {{ fila?.tempoEspera ?? '00:00' }}</span>
      </div>
    </div>
  </div>
  <div class="flex gap-5">
    @for (tag of fila?.tagsSessao?.slice(0, 2); track tag) {
      <div class="card-tag flex center-center">
        <span class="font-10 weight-700">{{ tag }}</span>
      </div>
    }
    @if (fila!.tagsSessao && fila!.tagsSessao.length > 2) {
      <div class="card-tag-plus flex center-center cursor-pointer" [matTooltip]="montarTextoTags()">
        <mat-icon>add</mat-icon>
      </div>
    }
  </div>
</div>
